var swiper = new Swiper(".blackFridaySwiper", {
    spaceBetween: 8,
    slidesPerView: 1,
    pagination: {
        el: ".blackFridaySwiperBox .swiper-pagination",
        clickable: true,
    },
});

$('#subscribe-button').on('click', function (e) {
    let email = $('#subscribe-email').val();
    console.log(email);
    if (email === '') {
        $('.subscribe-card').append(`<div class='tb-toast'>E-mail is required!!!</div>`);
        setTimeout(function () {
            $('.tb-toast').remove();
        }, 1000)
    }
    if (email) {
        $.ajax({
            url: 'https://backend.turboant.com/index/api/dealshopifycustomer',
            type: 'post',
            data: {
                account: 'turboant.myshopify.com',
                email: email
            },
            dataType: 'json',
            success: (res) => {
                const { status, msg } = res;
                if (status === 1) {
                    $('.subscribe-card').append(`<div class='tb-toast'>Subscribe to the success!</div>`);
                    setTimeout(function () {
                        $('.tb-toast').remove();
                    }, 1000)
                } else {
                    $('.subscribe-card').append(`<div class='tb-toast'>${msg}</div>`);
                    setTimeout(function () {
                        $('.tb-toast').remove();
                    }, 1000)
                }
            }
        });
    } else {
        $('.subscribe-card').append(`<div class='tb-toast'>E-mail is required!!!</div>`);
        setTimeout(function () {
            $('.tb-toast').remove();
        }, 1000)
    }

});


var swiper = new Swiper(".x7pro-ad-swiper", {
    loop:true,
    slidesPerView: isMobile() ? 1.2 : 1.8,
    spaceBetween: 0,
    centeredSlides: true,
    navigation: {
      nextEl: ".x7pro-ad-swiper .swiper-button-next",
      prevEl: ".x7pro-ad-swiper .swiper-button-prev",
    },
    on: {
      init: function () {
        const video = document.querySelector(".ad-video");
        if (video) {
         video.muted = true;
         video.play();       
        }
      },

    },
  });
  
  // Initialize Swiper
  swiper.init();

    // m10-lite-ad 头部倒计时
if ($("#v8-ad-countdown2").length > 0) {
    $.ajax({
      url: 'https://backend.turboant.com/index/api/getCountdownTime',
      type: 'get',
      data: {
        page: 'https://turboant.com/pages/electric-scooter-for-commuting'
      },
      dataType: 'json',
      success: (res) => {
        if (res.data.status === 1) {
          let time = res.data.time;
          $(`#v8-ad-countdown2`).timeTo({
            timeTo: new Date(time),
            theme: "black",
            displayDays: 2,
            displayCaptions: true,
            fontSize: !isMobile() ? 30 : 18,
            captionSize: !isMobile() ? 14 : 12,
            lang: 'en',
            countdown: true,
            languages: {
              en: {
                days: 'DAY',
                hours: 'HRS',
                min: 'MIN',
                sec: 'SEC',
              }
              
            }
          });
        }
      }
    });
  }
  
  if ($("#v8-ad-countdown2-wap").length > 0) {
    $.ajax({
      url: 'https://backend.turboant.com/index/api/getCountdownTime',
      type: 'get',
      data: {
        page: 'https://turboant.com/pages/electric-scooter-for-commuting'
      },
      dataType: 'json',
      success: (res) => {
        if (res.data.status === 1) {
          let time = res.data.time;
          $(`#v8-ad-countdown2-wap`).timeTo({
            timeTo: new Date(time),
            theme: "black",
            displayDays: 2,
            displayCaptions: true,
            fontSize: !isMobile() ? 30 : 20,
            captionSize: !isMobile() ? 14 : 12,
            lang: 'en',
            countdown: true,
            languages: {
              en: {
                days: '',
                hours: '',
                min: '',
                sec: '',
              }
              
            }
          });
        }
      }
    });
  }

$('.product-add-cart-botton').on('click', function (e) {
    let id = $(this).data('variantid') || $(this).data('id');
    console.log(id);
    addCartFn(id)
})

$('.product-variant').on('click', function (e) {

    let id = $(this).data('variant-id');
    let product_id = $(this).data('product-id');
    console.log(id);
    let selectStr = '#variant-add-cart-' + product_id;
    $(selectStr).data('variantid', id);
    $(selectStr).attr('data-variantid', id);

    // Toggle active color state within the same product card
    let $variants = $('.product-variant[data-product-id="' + product_id + '"]');
    $variants.removeClass('tw-bg-[#272727] tw-text-white').addClass('tw-text-black');
    $(this).addClass('tw-bg-[#272727] tw-text-white').removeClass('tw-text-black');
});

let time = $('.active-countdown').data('time');
$(`#countdown`).timeTo({
  timeTo: new Date(time),
  theme: "black",
  displayDays: 2,
  displayCaptions: true,
  fontSize: !isMobile() ? 26 : 18,
  captionSize: !isMobile() ? 14 : 13,
  lang: 'en',
  countdown: true
});

let time2 = $('.active-countdown-top').data('time');
$(`#countdown-top`).timeTo({
  timeTo: new Date(time2),
  theme: "black",
  displayDays: 2,
  displayCaptions: true,
  fontSize: !isMobile() ? 26 : 18,
  captionSize: !isMobile() ? 14 : 13,
  lang: 'en',
  countdown: true
});

var repairSwiper = new Swiper(".repairSwiper", {
  slidesPerView: 2,
  slidesPerGroup : 2,
  grid: {
    rows: 2,
  },
  spaceBetween: 12,
  navigation: {
    nextEl: ".repairSwiperContainer .swiper-button-next",
    prevEl: ".repairSwiperContainer .swiper-button-prev",
  },
});


var mobileRepairNavSwiper = new Swiper(".mobileRepairNavSwiper", {
  slidesPerView: 4.5,
  spaceBetween: 12,
});

var mobileRepairSwiper = new Swiper(".mobileRepairSwiper", {
  slidesPerView: isMobile() ? 1.2 : 2,
  spaceBetween: isMobile() ? 12 : 24,
  loop: true,
  centeredSlides: true,
  // initialSlide: 1, // 设置初始显示的slide为第二个
  navigation: {
    nextEl: ".mobileRepairSwiperContainer .swiper-button-next",
    prevEl: ".mobileRepairSwiperContainer .swiper-button-prev",
  },
  pagination: {
    el: ".mobileRepairSwiperContainer .swiper-pagination",
  },
});
